import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { I18nProvider } from "./context/I18nContext";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AppLayout from "./components/AppLayout";
import Dashboard from "./pages/Dashboard";
import Posts from "./pages/Posts";
import AIGenerator from "./pages/AIGenerator";
import Candidates from "./pages/Candidates";
import Messaging from "./pages/Messaging";
import Forms from "./pages/Forms";
import Notifications from "./pages/Notifications";
import PublicForm from "./pages/PublicForm";
import Billing from "./pages/Billing";
import Pricing from "./pages/Pricing";

const ProtectedRoute = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
};

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/f/:slug" element={<PublicForm />} />
              <Route path="/app" element={<ProtectedRoute><Dashboard/></ProtectedRoute>} />
              <Route path="/app/posts" element={<ProtectedRoute><Posts/></ProtectedRoute>} />
              <Route path="/app/ai" element={<ProtectedRoute><AIGenerator/></ProtectedRoute>} />
              <Route path="/app/candidates" element={<ProtectedRoute><Candidates/></ProtectedRoute>} />
              <Route path="/app/messaging" element={<ProtectedRoute><Messaging/></ProtectedRoute>} />
              <Route path="/app/forms" element={<ProtectedRoute><Forms/></ProtectedRoute>} />
              <Route path="/app/notifications" element={<ProtectedRoute><Notifications/></ProtectedRoute>} />
              <Route path="/app/billing" element={<ProtectedRoute><Billing/></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
